var $j = jQuery;
$j(function($) {
  $j('.variant-price-section-dp select').on('change', function () {

  var $select = $j(this);
  var vps_pid = $select.parent().data('pid');
  var vps_val = ($select.val() || '').toString();

  // Hide all
  $select
    .parent()
    .siblings('.variant-price-section')
    .removeClass('active')
    .hide();

  // Activate safely
  $j('.variant-price-section').filter(function () {
    return (
      String($j(this).attr('data-pid')) === String(vps_pid) &&
      String($j(this).attr('data-variant')) === vps_val
    );
  }).addClass('active').show();

  // Safe price update
  var price = $select
    .parent()
    .siblings('.active')
    .find('.pricefilter')
    .val() || 0;

  $select.closest('.product-type-list').attr('data-price', price);

  calculatePriceonBuilder();
});

  $('button#AddToCart-premier-builder-template').on('click', function(evt) {

    evt.preventDefault();
    
    $(this).prop('disabled', true);
    
    $('#the-main-product-builder .product-types').each(function(){
      var currentlySelectedOnBuilder = $(this).find('.product-type-list.active');
      //currentlySelectedVariantOnBuilder
      var csvob = currentlySelectedOnBuilder.find('.variant-price-section.active');
      var currentProduct_type = csvob.find('.product_pb_properties').val();
      var currentProductID = csvob.find('.product-id-pb').val();
      var currentProductArray = csvob.find('.product_pb_prop_arr').val();
      var product_pb_qty = 1;
      
      var notValid = false;
      var xProducts = false;
      if( currentProductID === undefined || currentProductID === null ) {
        notValid = true;
      }
      if( currentProduct_type == "Men's Kilt" || currentProduct_type == "Men's Shirt" || currentProduct_type == "Dance Hose" || currentProduct_type == "Kilt" || currentProduct_type == "Jacket" || currentProduct_type == "Dance Vest" || currentProduct_type == "Dance Skirt" ) {
        xProducts = true;
      }
      if( !notValid && !xProducts ) {
      	$('#product-variants-container').append('<input type="checkbox" name="id[]" value="'+currentProductID+'" id="radio_'+currentProductID+'" checked="checked" style="display:none;" />');
      } else if ( !notValid && xProducts ) {
        var currentID = csvob.find('.product-id-pb').data('prod-id');
        $('#prod_id_'+ currentID).val(currentProductID);
        console.log('#prod_id_'+ currentProductID + ', variant - ' + currentID);
      }
    });
    
    $('.add-product-item.active').each(function(){
      var currentAddVariant = $(this).find('.add-product-variant.active');
      var currentAddId = currentAddVariant.find('.add-product-variant-id').val();
      if( currentAddId !== undefined && currentAddId !== null ) {
        $('#product-variants-container').append('<input type="checkbox" name="id[]" value="'+currentAddId+'" id="radio_'+currentAddId+'" checked="checked" style="display:none;" />');
      }
    });
	
    $('form[action="/cart/add"]').each(function() {
      if ( $(this).closest('.product-type-list.active').length || $(this).attr('id') == "MainForm" ) {
        $.ajax({
          type: "POST",
          async: false,
          url: '/cart/add',
          data: $(this).serialize(),
          success: function (data) {	
            console.log('success!');    
          },
          error: function(jqXHR, text, error){
            console.log(error);       
          }
        });
      }
    }).promise().done(function() {
      console.log('finished!');
      window.location.href = "/cart";
    });
    
   	//setTimeout( function(){ $('form[action="/cart/add"]').submit(); }, 2000 );

  });

//   $('button#AddToCart-premier-builder-template').on('click', function (e) {
//     e.preventDefault();

//   var items = [];

//   console.group('🛒 Builder Add to Cart');

//   // Builder products
//   $('#the-main-product-builder .product-type-list.active').each(function () {
//     var variantId = $(this)
//       .find('.variant-price-section.active .product-id-pb')
//       .val();

//     if (variantId) {
//       items.push({
//         id: variantId,
//         quantity: 1
//       });

//       console.log('Added builder variant:', variantId);
//     }
//   });

//   // Additional products
//   $('.add-product-item.active').each(function () {
//     var variantId = $(this)
//       .find('.add-product-variant.active .add-product-variant-id')
//       .val();

//     if (variantId) {
//       items.push({
//         id: variantId,
//         quantity: 1
//       });

//       console.log('Added additional variant:', variantId);
//     }
//   });

//   console.log('Final items payload:', items);
//   console.groupEnd();

//   if (!items.length) {
//     alert('No products selected');
//     return;
//   }

//   // ONE request only
//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify({ items })
//   })
//     .then(r => r.json())
//     .then(data => {
//       console.log('Cart add success:', data);
//       window.location.href = '/cart';
//     })
//     .catch(err => {
//       console.error('Cart add error:', err);
//       alert('Failed to add to cart');
//     });
// });



  $('.builder-product-change a').each(function() {
    $(this).on('click', function(e){
      e.preventDefault();
      var MainParent = $(this).closest('.builder-main-item');
      var productType = MainParent.find('.product-type-list');
      if (!$(this).is('.btn-remove')) {
        MainParent.addClass('testing_parent');
        $('.custom-builder-inner .page-width').html('');
        $('.custom-builder-inner .page-width').append('<h2>Select ' + MainParent.data('type') + '</h2>');
        $('.custom-builder-inner .page-width').append('<div class="currently-selected"><div class="currently-selected-wrap"></div></div>');


        var product_currently_selected = $(this).closest('.product-type-list');

        $('.custom-builder-inner .page-width .currently-selected .currently-selected-wrap').append(product_currently_selected.find('.a-product-image').html() );
        $('.custom-builder-inner .page-width .currently-selected .currently-selected-wrap').append('<h4>Currently Selected:</h4>');
        $('.custom-builder-inner .page-width .currently-selected .currently-selected-wrap').append(product_currently_selected.find('.builder-product-title').text() );

        $('.custom-builder-inner .page-width').append('<div class="product-list-type-wrap" />');
        $('.custom-builder-inner .page-width .product-list-type-wrap').append( MainParent.html() );
        $('.custom-builder-inner .page-width').find('.product-type-list').removeClass('active').removeAttr('style');

        $('#custom-builder-pop-up').fadeIn(200);
        $('#custom-builder-pop-up-bg').fadeIn(200);
        $('.custom-builder-inner').fadeIn(200);

        $('.custom-builder-inner').delegate('.product-type-list','click',function() {
            console.log( $(this).data('ntype') );
          
			var targetP = $('#the-main-product-builder .product-types .product-type-list[data-ptype="' + $(this).data('ptype') + '"]');
          	var targetS = targetP.find('.variant-price-section.active').find('.available').val();
            
            $('#the-main-product-builder .product-type-list[data-ntype="'+$(this).data('ntype')+'"]').removeClass('active').css('display','none');
            if (targetS  == 'true') {
          	  targetP.addClass('active').css('display','block');
            } else {
              targetP.removeClass('active').addClass('unavailable-variant').css('display','block');
            }

            $('.custom-builder-inner .page-width').html('');

            calculatePriceonBuilder();

            $('.custom-builder-inner').slideUp(2000);
            $('#custom-builder-pop-up').fadeOut(200);
            $('#custom-builder-pop-up-bg').fadeOut(200);

            MainParent.removeClass('removed');
        });

      } else {

        MainParent.addClass('removed');
        productType.removeClass('active');
        calculatePriceonBuilder();

      }
    });
  });

  $('#custom-builder-pop-up-bg').on('click', function(e){
    e.preventDefault();
    $('.custom-builder-inner .page-width').html('');
    $('#custom-builder-pop-up').fadeOut(200);
    $('#custom-builder-pop-up-bg').fadeOut(200);
    $('.custom-builder-inner').fadeOut(200);
    $('.size-chart-inner').fadeOut(200);
  });
  
  $('.builder-product-change-tartan a').on('click',function(e){
	e.preventDefault();
	
	var prod_id = $('#MainProductIDHidden').val();
	
	$('.custom-builder-inner .page-width').html('');
	
	var tartan_db_link = '/pages/tartan-database';
	$.get(tartan_db_link, function(data) {
		 
		$('.custom-builder-inner .page-width').append('<h2>Select tartan</h2>');
		var tartan_search = $('#tartandatabase-header',data);
		$('.custom-builder-inner .page-width').append(tartan_search);
		
		var tartan_headers = $("#tartandatabase-content ul.sa_fletter", data);
		$('.custom-builder-inner .page-width').append(tartan_search);
		
		var tartan_all_products = $("#tartan-all-products-container", data);
		var product_list = tartan_all_products[0].innerHTML;
		
		product_list = product_list.replace(/PRODUCT_ID_REPLACE/g, prod_id);
		
		
		$('.custom-builder-inner .page-width').append(product_list);
		
		$('.custom-builder-inner').delegate('.product-type-list-tartan','click',function() {
			var this_box = $(this);
			$('.custom-builder-inner .product-type-list-tartan').css('display','none');
			$(this).addClass('active').css('display','block');
		});
		
		$('#custom-builder-pop-up').fadeIn(200);
		$('#custom-builder-pop-up-bg').fadeIn(200);
		$('.custom-builder-inner').fadeIn(200);

	});
  });
  
  $('.product-form__input').prop('selectedIndex',0);
  
  $('.product-type-list').filter(':visible').each(function() {
    var activeVariant = $(this).find('.variant-price-section.active');
    var stat = activeVariant.find('.available').val();
    if ( stat == 'true' ) {
      $(this).addClass('active');
    } else {
      $(this).removeClass('active');
      $(this).addClass('unavailable-variant');
    }
  });
  
  $('.add-product-item').each(function() {
    var activeVariant = $(this).find('.add-product-variant.active');
    var stat = activeVariant.find('.available').val();
    var addBtn = $(this).find('.btn-add-item');
    if ( stat == 'false' ) {
      $(this).addClass('unavailable-variant');
      addBtn.addClass('btn-disabled');
    }
  });
  
  $('.btn-sizechart').on('click', function() {
  	var id = $(this).attr('href');
    $('#custom-builder-pop-up').fadeIn(200);
    $('#custom-builder-pop-up-bg').fadeIn(200);
	  $(id +'.size-chart-inner').fadeIn(200);
  });

  $('.measuremnt-form-file.btn-sizechart').on('click', function() {
    var modal_image = $(this).attr("data-img");
    var id = $(this).attr('href');
    $(id +'.size-chart-inner').html("<img style='display: block; margin: 0 auto;' src='" + modal_image + "'/>");
    $('#custom-builder-pop-up').fadeIn(200);
    $('#custom-builder-pop-up-bg').fadeIn(200);
	  $(id +'.size-chart-inner').fadeIn(200);
  });

  //Sticky header
  $(window).scroll( function() {
    var scrollTop = $(this).scrollTop();
    if (scrollTop + $(this).height() >= $(document).height() - 200) {
      $('body').removeClass('is-scrolled');
    } else if (scrollTop <= 0) {
      $('body').removeClass('is-scrolled');
    } else {
      $('body').addClass('is-scrolled');
    }
  });

});